/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
// @ts-nocheck
import React, { useEffect, useState } from 'react';
import ReactFlow, {
  MiniMap,
  useEdgesState,
  MarkerType,
  Background,
  useNodesState,
  Controls,
} from 'reactflow';
import 'reactflow/dist/style.css';
import { Helmet } from 'react-helmet';
// eslint-disable-next-line import/no-extraneous-dependencies
import dagre from 'dagre';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { cloneDeep } from 'lodash';
import { useSelector } from 'react-redux';
import { withTransaction } from '@elastic/apm-rum-react';
import PipelineNodeEditorModal from '../../components/Pipeline/PipelineNodeEditorModal';
import PipelineNode from '../../components/Pipeline/PipelineNode';
import NormalOperationPipelineNode from '../../components/Pipeline/NormalOperationPipelineNode';
import ParentPipelineNode from '../../components/Pipeline/ParentPipelineNode';
import useProject from '../../Hooks/Project/useProject';
import usePipeline from '../../Hooks/Pipeline/usePipeline';
import { SwalToast } from '../../components/Common';
import useDocumentation from '../../Hooks/Documentation/useDocumentation';
import useModelMetaData from '../../Hooks/useModelMetaData';
import { DATASET_REQUIRED_FIELDS } from '../../const/CommonConst';
import useUDFManager from '../../Hooks/UDFManager/useUDFManager';
import useWorker from '../../Hooks/Worker/useWorker';
import MODULE_SUB_MODULE_OPERATIONS_TREE from '../../const/ModuleSubModuleOperationsTree';

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const edgeOptions = {
  animated: true,
  style: {
    stroke: 'black',
  },
  markerEnd: {
    type: MarkerType.ArrowClosed,
    color: 'black',
  },
};
const defaultNodes = [
  // {
  //   id: 'a',
  //   type: 'input',
  //   data: { label: 'Node A' },
  //   position: { x: 250, y: 25 },
  // },
  // {
  //   id: 'b',
  //   data: { label: 'Node B' },
  //   position: { x: 100, y: 125 },
  // },
  // {
  //   id: 'c',
  //   type: 'output',
  //   data: { label: 'Node C' },
  //   position: { x: 250, y: 250 },
  // },
];

const defaultEdges = [];

const connectionLineStyle = { stroke: 'black' };

/**
 * @function  EditPipeline
 * @description  EditPipeline component..
 * Allows users to edit pipelines.
 * @returns {JSX}
 */

const EditPipeline = () => {
  const { permissions } = useSelector((state) => state.user);
  const ListPipelinePermission =
    permissions[
      `${MODULE_SUB_MODULE_OPERATIONS_TREE.PIP.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.PIP.subModules.LP.key}`
    ];
  const ListPublishedPipelinePermission =
    permissions[
      `${MODULE_SUB_MODULE_OPERATIONS_TREE.PIP.key}_${MODULE_SUB_MODULE_OPERATIONS_TREE.PIP.subModules.LPP.key}`
    ];
  const {
    fetchDatasetColumnDetailsForConsole,
    fetchAllModels,
    fetchConsoleFileListAll,
  } = useUDFManager();
  const {
    project,
    datasetList,
    fetchDatasetList,
    lockArtifact,
    unlockArtifact,
  } = useProject();
  const navigate = useNavigate();
  const { docEditorOverview, fetchEditorOverview } = useDocumentation();
  const { readPipeLine, fetchNodeDetail, fetchPipelines } = usePipeline();
  const { fetchPods } = useWorker();
  const [consoleFileList, setConsoleFilesList] = useState([]);
  const [modeleMetaDataSchema, setModelMetaDataSchema] = useState(null);
  const { fetchModelMetaDataSchema } = useModelMetaData();
  const params = useParams();
  const pipelineId = Number(params?.id);
  const [pipelineData, setPipelineData] = useState();

  const theme = useTheme();
  const [nodes, setNodes] = useNodesState(defaultNodes);
  const [edges, setEdges] = useEdgesState(defaultEdges);
  const [isShowNodeEditModal, setIsShowNodeEditModal] = useState(false);
  const [nodeData, setNodeData] = useState({});

  const showToModelMetaDataOption = React.useMemo(
    () =>
      project?.activeProject?.system_generated_flag &&
      project?.activeProject?.system_name === 'Vault',
    [project]
  );

  /**
   * @function fetchPipelinedDetails
   * @description  to fetch pipeline details by pipeline id
   * @param {number} pipeId pipeline id
   * @returns {void} void
   *
   */
  const fetchPipelinedDetails = (pipeId) => {
    readPipeLine(
      pipeId,
      project?.activeProject?.project_id,
      [
        'flow_display',
        'pipeline_id',
        'pipeline_display_name',
        'nodes_count',
        'pipeline_setting',
        'description',
        'pipeline_tag',
        'pipeline_arguments',
        'defective_node',
      ].join()
    ).then((res) => {
      setPipelineData(res?.data?.pipelines);
      setNodes(
        res?.data?.pipelines?.flow_display?.nodes
          ? res?.data?.pipelines?.flow_display?.nodes
          : []
      );
      setEdges(
        res?.data?.pipelines?.flow_display?.edges
          ? res?.data?.pipelines?.flow_display?.edges
          : []
      );
    });
  };

  useEffect(() => {
    if (project?.activeProject?.is_collaborative && pipelineData) {
      lockArtifact({
        artifact_id: pipelineData?.pipeline_id,
        artifact_name: pipelineData?.pipeline_display_name,
        project_id: project?.activeProject?.project_id,
        artifact_type: 'pipeline',
        is_getting_accessed: true,
      }).then((res) =>
        SwalToast({
          icon: 'success',
          title: res?.data?.msg,
        })
      );
      return () => {
        const payload = {
          artifact_id: pipelineData?.pipeline_id,
          artifact_name: pipelineData?.pipeline_display_name,
          project_id: project?.activeProject?.project_id,
          artifact_type: 'pipeline',
        };
        unlockArtifact(payload).then((res) => {
          SwalToast({
            icon: 'success',
            title: res.data.msg,
          });
        });
      };
    }
  }, [pipelineData]);

  useEffect(() => {
    fetchPipelinedDetails(pipelineId);
  }, [pipelineId]);
  useEffect(() => {
    fetchConsoleFileListAll(
      project?.activeProject?.project_id,
      ['id', 'name'].join()
    ).then((resp) => {
      setConsoleFilesList(resp.data);
    });
  }, [project?.activeProject?.project_id]);

  /**
   * @function onNodeClick
   * @description  to update node Data
   */
  const onNodeClick = (_event, node) => {
    if (node?.type !== 'resizeRotate') {
      fetchNodeDetail(project?.activeProject?.project_id, node?.nodeId).then(
        (res) => {
          const extraNodeData = {
            ...pipelineData?.flow_display?.nodes?.find((n) => {
              return n?.nodeId === node?.nodeId;
            }),
          };
          setNodeData({
            ...extraNodeData,
            ...res?.data?.node,
          });
          setIsShowNodeEditModal(true);
        }
      );
    }
  };

  React.useEffect(() => {
    fetchDatasetList(
      project?.activeProject?.project_id,
      true,
      [
        DATASET_REQUIRED_FIELDS,
        'mvperc',
        'categorical_threshold',
        'stages',
        'fields',
      ].join()
    );

    let isPublished = null;
    if (
      ListPipelinePermission === 'Yes' &&
      ListPublishedPipelinePermission === 'Yes'
    ) {
      isPublished = null;
    } else if (ListPipelinePermission === 'Yes') {
      isPublished = false;
    } else {
      isPublished = true;
    }

    fetchPipelines(
      project?.activeProject?.project_id,
      ['pipeline_id'].join(),
      isPublished
    ).then((res) => {
      const pipelineIds = res?.data?.pipelines?.filter((ele) => {
        return ele.pipeline_id === pipelineId;
      });
      if (pipelineIds.length === 0) {
        navigate('/pipeline/list');
      }
    });
    if (showToModelMetaDataOption) {
      fetchModelMetaDataSchema({
        project_id: project?.activeProject?.project_id,
        type: project?.activeProject?.type,
      }).then(
        (resp) => {
          setModelMetaDataSchema(resp?.data);
        },
        () => {
          setModelMetaDataSchema(null);
        }
      );
    }
  }, [
    project?.activeProject?.project_id,
    ListPipelinePermission,
    ListPublishedPipelinePermission,
  ]);

  const onPaneClick = () => {
    setIsShowNodeEditModal(false);
  };

  const nodeTypes = React.useMemo(
    () => ({
      consoleJobNode: PipelineNode,
      normal: NormalOperationPipelineNode,
      resizeRotate: ParentPipelineNode,
    }),
    [PipelineNode, NormalOperationPipelineNode, ParentPipelineNode]
  );
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        height="100vh" // Ensures the parent container takes the full viewport height
        width="100vw" // Ensures it takes the full viewport width
        pl="24px"
        pr="24px"
        pt="15px"
      >
        <Helmet>
          <title>Pipeline Manager | Nimbus Uno</title>
        </Helmet>

        <Grid item xs={12}>
          <Box mb={1} display="flex">
            <Typography variant="body4">
              <strong>Note:</strong>&nbsp;
              <i>
                &nbsp;Pipelines are designed to produce a consistent number of
                outputs from their nodes. Modifying the number of outputs or
                introducing nodes with variable output can lead to pipeline
                execution failures. It is advisable to incorporate new nodes
                instead. Alternatively, for nodes that may have changing
                outputs, consider avoiding document mapping and I/O mapping.
              </i>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sx={{ flex: 1, display: 'flex' }} mb={2}>
          <Box sx={{ overflow: 'hidden', position: 'relative', flex: 1 }}>
            {!nodes?.length ? (
              <Box right="42%" top="50%" position="absolute" zIndex="1">
                <Typography
                  tabIndex={0}
                  sx={() => ({
                    '&:focus-visible': {
                      outline: 'none',
                      border: `2px solid ${theme?.palette?.primary?.main} !important`,
                    },
                  })}
                >
                  Please add at least one node to get started.
                </Typography>
              </Box>
            ) : null}

            <ReactFlow
              nodes={nodes}
              edges={edges}
              defaultEdgeOptions={edgeOptions}
              defaultViewport={{ x: 0, y: 0, zoom: 1 }}
              maxZoom={1.5}
              fitView
              nodeTypes={nodeTypes}
              elementsSelectable={false}
              nodesConnectable={false}
              nodesDraggable={false}
              edgesFocusable={false}
              onNodeClick={onNodeClick}
              onPaneClick={onPaneClick}
              style={{
                backgroundColor: theme.palette.other.white,
                borderRadius: '8px',
                border: `0.5px solid ${theme.palette.primary.main}`,
                height: '100%', // Takes full height
                width: '100%', // Takes full width
              }}
              connectionLineStyle={connectionLineStyle}
              zIndex={-1}
              onlyRenderVisibleElements={true}
            >
              <Background
                variant="lines"
                gap={30}
                size={0.4}
                lineWidth={0.5}
                color={theme.palette.secondary.main}
              />
              <MiniMap
                nodeStrokeWidth={3}
                style={{
                  boxShadow: '0px 3px 15px rgba(0,0,0,0.1)',
                  border: '0.2px solid black',
                }}
              />
              <Controls
                style={{
                  boxShadow: '0px 3px 15px rgba(0,0,0,0.1)',
                  border: '0.2px solid black',
                }}
              />
            </ReactFlow>
          </Box>
        </Grid>
      </Box>

      {isShowNodeEditModal && (
        <PipelineNodeEditorModal
          open={isShowNodeEditModal}
          handleClose={() => {
            setIsShowNodeEditModal(false);
          }}
          nodeData={cloneDeep(nodeData)}
          activeProject={project.activeProject}
          fetchAllModels={fetchAllModels}
          fetchDatasetColumnDetails={fetchDatasetColumnDetailsForConsole}
          datasetList={datasetList}
          pipelineData={pipelineData}
          allPermissions={permissions}
          docEditorOverview={docEditorOverview}
          fetchEditorOverview={fetchEditorOverview}
          modeleMetaDataSchema={modeleMetaDataSchema}
          showToModelMetaDataOption={showToModelMetaDataOption}
          consoleFileList={consoleFileList}
          fetchPods={fetchPods}
          readOnly={true}
        />
      )}
    </>
  );
};

export default withTransaction('EditPipeline', 'component')(EditPipeline);
